import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_call-filter",
  "use": "svg_call-filter-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_call-filter\"><path d=\"M3.4 0v18h11.2V0H3.4zm10.1 16.9h-9v-1.7h3.4v1.1h2.2v-1.1h3.4v1.7zm0-2.8h-9v-13h9v13z\" /><path d=\"M9 12.2c2-1.2 3.4-3.1 3.4-5.2V4.5H5.6v2.6c0 2 1.4 3.9 3.4 5.1zM6.8 5.6h4.5V7c0 1.4-.8 2.8-2.2 3.8-1.4-1-2.2-2.4-2.2-3.8V5.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol